import slice, { saga } from "./slice";

const fileReducer = slice.reducer;
const fileActions = slice.actions;
const fileSaga = saga;

export { fileReducer, fileActions, fileSaga };
